import { RelocationOrderFlowAction } from "@/common/api/relocation-order-flow/_helpers/resolve-relocation-order-flow-path";
import { NewDatePage } from "./_components/new-date-page";

export function NewDateView() {
  return (
    <NewDatePage
      flowAction={RelocationOrderFlowAction.TransportCompanySetPickupDate}
      backTo="~/fit/relocation-request"
      navigateToOnSuccess="/fit/relocation-request"
    />
  );
}
